<template>
  <div>
    <div class="card">
      <!-- 
      <div class="card-image">
        <figure class="image is-4by3">
          <img
            src="https://bulma.io/images/placeholders/1280x960.png"
            alt="Placeholder image"
          />
        </figure>
      </div>-->
      <div class="card-content">
        <div class="media">
          <div class="media-left">
            <figure class="image is-64x64">
              <img :src="proj.avatar" alt="" />
            </figure>
          </div>
          <div class="media-content">
            <p class="title is-4">{{ proj.id }}</p>
            <p class="subtitle is-6">
              <b-tag v-if="proj.nbOps" rounded type="  is-light">{{ proj.nbOps }} functions</b-tag>
              <span v-if="proj.apiBaseUrl" type="i  is-light" style="font-size: 12px">{{
                String(proj.apiBaseUrl).replace("https://", "")
              }}</span>
            </p>
          </div>
        </div>
        <div class="content">
          <p class=" ">{{ proj.desc }}</p>
        </div>
        <!-- 🚧
        <div class="content">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec
          iaculis mauris. <a>@bulmaio</a>. <a href="#">#css</a>
          <a href="#">#responsive</a>
          <br />
          <time datetime="2016-1-1">11:09 PM - 1 Jan 2016</time>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { MethodColors } from "@/common/utils.js";

export default {
  name: "HelloWorld",
  props: {
    proj: Object,
  },
  data() {
    return {
      MethodColors,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.card-content {
  padding: 19px;
}
</style>
